<template>
    <div class="our-mission-area ptb-100" id="real-world-data">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="our-mission-content">
                        <div class="content">
                            <h2>Filozofia Atelierului Nostru</h2>
                            <p>Conceptul 'Atelierului' reflectă însăși esența filozofiei noastre. Pentru noi, software-ul nu este o linie de asamblare. Abordăm fiecare proiect cu atenția unui meșter: ascultăm, analizăm, proiectăm și 'șlefuim' fiecare linie de cod până când soluția funcționează impecabil. Nu livrăm produse 'la cheie', ci construim instrumente digitale personalizate, perfect adaptate ADN-ului afacerii tale.</p>
                            <!-- <ul class="features-list">
                                <li><i class="flaticon-tick"></i> Leadership-Focused Learning</li>
                                <li><i class="flaticon-tick"></i> Experts at Teaching Online</li>
                                <li><i class="flaticon-tick"></i> Proven Career Outcomes</li>
                                <li><i class="flaticon-tick"></i> Diverse Backgrounds Welcome</li>
                                <li><i class="flaticon-tick"></i> The Basics of Machine Learning</li>
                            </ul> -->
                            <p>Scopul nostru final este ca <i>tehnologia</i> să devină cel mai de încredere angajat al dumneavoastră.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="our-mission-image">
                        <img src="../assets/images/our-mission/filozofia.png" alt="image">
                        <div class="shape"><img src="../assets/images/our-mission/our-mission-shape1.png"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ASFilozofiaNoastra'
}
</script>